export const DAILY_FORCE_RECORD_STORAGE_KEY = 'NEXTROUND_POWER_PUNCH_DAILY_HIGH_V1'

export interface DailyForceRecord {
  date: string
  force: number
}

const getLocalDateKey = (date: Date): string => {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export const readDailyForceRecord = (
  storage: Storage = window.localStorage,
  now: Date = new Date()
): DailyForceRecord => {
  const emptyRecord = { date: getLocalDateKey(now), force: 0 }

  try {
    const storedRecord = storage.getItem(DAILY_FORCE_RECORD_STORAGE_KEY)
    if (!storedRecord) return emptyRecord

    const parsedRecord = JSON.parse(storedRecord)
    const force = Number(parsedRecord.force)
    if (parsedRecord.date !== emptyRecord.date || !Number.isFinite(force) || force < 0) return emptyRecord

    return { date: emptyRecord.date, force: Math.round(force) }
  } catch {
    return emptyRecord
  }
}

export const updateDailyForceRecord = (
  force: number,
  storage: Storage = window.localStorage,
  now: Date = new Date()
): { record: DailyForceRecord; isNewRecord: boolean } => {
  const currentRecord = readDailyForceRecord(storage, now)
  const roundedForce = Math.max(0, Math.round(force))
  const isNewRecord = roundedForce > currentRecord.force
  const record = isNewRecord ? { ...currentRecord, force: roundedForce } : currentRecord

  try {
    storage.setItem(DAILY_FORCE_RECORD_STORAGE_KEY, JSON.stringify(record))
  } catch {
    // A blocked or full localStorage should not interrupt an active workout.
  }

  return { record, isNewRecord }
}
